import { FaturavelTipo } from '../generated/backend-enums.js';
export { FaturavelTipo };
export const FaturavelTipoMap = {
    [FaturavelTipo.ATENDIMENTO]: 'Atendimento',
    [FaturavelTipo.ATIVACAO]: 'Ativação',
    [FaturavelTipo.BRINDES]: 'Brindes',
    [FaturavelTipo.DIVERSOS]: 'Diversos',
    [FaturavelTipo.EVENTO_FISICO]: 'Evento Físico',
    [FaturavelTipo.FEE]: 'Fee',
    [FaturavelTipo.INCENTIVO]: 'Incentivo',
    [FaturavelTipo.MATERIAIS]: 'Materiais',
    [FaturavelTipo.MPDV]: 'MPDV',
    [FaturavelTipo.PROMOCAO]: 'Promoção',
    [FaturavelTipo.TRIANGULACAO]: 'Triangulação',
};
